module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "company"
    }
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Company Details")]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "edit",
      "subject": "company-details"
    }
  }, [_c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = !_vm.dialogVisible
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Contact, location and other various details related to my station.\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.company),
      expression: "!company"
    }],
    staticClass: "ibox-content"
  }, [(_vm.company && _vm.company.logoImage) ? _c('div', {
    staticClass: "company-logo"
  }, [(_vm.company.logoImage) ? _c('img', {
    attrs: {
      "src": _vm.company.logoImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.company.logoImage) ? _c('hr') : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.company) ? _c('div', [(_vm.company.title) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Title:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.title))])]) : _vm._e(), _vm._v(" "), (_vm.company.webSite) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Website:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('a', {
    attrs: {
      "href": _vm.company.webSite,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.company.webSite))])]), _vm._v(" "), (_vm.company.telephoneNumber) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Telephone no:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.telephoneNumber))])]) : _vm._e(), _vm._v(" "), (_vm.company.faxNumber) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Fax no:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.faxNumber))])]) : _vm._e(), _vm._v(" "), (_vm.company.timezone) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Timezone:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.timezone))])]) : _vm._e(), _vm._v(" "), (_vm.company.woeid) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("WOEID:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.woeid))])]) : _vm._e(), _vm._v(" "), (_vm.company.cumulativeAudience) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Cume:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.cumulativeAudience.toLocaleString()))])]) : _c('br')]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.company) ? _c('el-dialog', {
    attrs: {
      "title": "Edit Company",
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "150px",
      "model": _vm.company
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Title"
    },
    model: {
      value: (_vm.company.title),
      callback: function($$v) {
        _vm.$set(_vm.company, "title", $$v)
      },
      expression: "company.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Short Name",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Short Name"
    },
    model: {
      value: (_vm.company.shortName),
      callback: function($$v) {
        _vm.$set(_vm.company, "shortName", $$v)
      },
      expression: "company.shortName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "webSite"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Website"
    },
    model: {
      value: (_vm.company.webSite),
      callback: function($$v) {
        _vm.$set(_vm.company, "webSite", $$v)
      },
      expression: "company.webSite"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Format",
      "prop": "format"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Format"
    },
    model: {
      value: (_vm.company.format),
      callback: function($$v) {
        _vm.$set(_vm.company, "format", $$v)
      },
      expression: "company.format"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Genre",
      "prop": "genre"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Genre"
    },
    model: {
      value: (_vm.company.genre),
      callback: function($$v) {
        _vm.$set(_vm.company, "genre", $$v)
      },
      expression: "company.genre"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telephone no.",
      "prop": "telephoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Telephone no."
    },
    model: {
      value: (_vm.company.telephoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "telephoneNumber", $$v)
      },
      expression: "company.telephoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fax no.",
      "prop": "faxNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Fax no."
    },
    model: {
      value: (_vm.company.faxNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "faxNumber", $$v)
      },
      expression: "company.faxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.company.country),
      callback: function($$v) {
        _vm.$set(_vm.company, "country", $$v)
      },
      expression: "company.country"
    }
  }, _vm._l((_vm.countries), function(country, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": country.name,
        "value": country.alpha2
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Select State",
      "disabled": _vm.regions.length === 0,
      "filterable": ""
    },
    model: {
      value: (_vm.company.state),
      callback: function($$v) {
        _vm.$set(_vm.company, "state", $$v)
      },
      expression: "company.state"
    }
  }, _vm._l((_vm.regions), function(region, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": region.name,
        "value": region.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Timezone",
      "prop": "timezone"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Select Timezone",
      "loading": _vm.loadingTimezones,
      "filterable": ""
    },
    model: {
      value: (_vm.company.timezone),
      callback: function($$v) {
        _vm.$set(_vm.company, "timezone", $$v)
      },
      expression: "company.timezone"
    }
  }, _vm._l((_vm.timezones), function(timezone, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": timezone[1],
        "value": timezone[0]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "WOEID",
      "prop": "woeid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "WOEID"
    },
    model: {
      value: (_vm.company.woeid),
      callback: function($$v) {
        _vm.$set(_vm.company, "woeid", $$v)
      },
      expression: "company.woeid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cume",
      "prop": "cume"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cume"
    },
    model: {
      value: (_vm.company.cumulativeAudience),
      callback: function($$v) {
        _vm.$set(_vm.company, "cumulativeAudience", $$v)
      },
      expression: "company.cumulativeAudience"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Station Logo"
    }
  }, [_c('el-upload', {
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "image/*",
      "on-change": _vm.handleLogoImageChange,
      "on-remove": _vm.handleFileRemove,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n            Drop file here or\n            "), _c('em', [_vm._v("click to upload")])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Survey Logo"
    }
  }, [_c('el-upload', {
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "image/*",
      "on-change": _vm.handleSurveyImageChange,
      "on-remove": _vm.handleFileRemove,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n            Drop file here or\n            "), _c('em', [_vm._v("click to upload")])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opt-in Keywords"
    }
  }, [_vm._l((_vm.company.optinKeywords), function(keyword) {
    return _c('el-tag', {
      key: keyword,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(_vm.company.optinKeywords, keyword)
        }
      }
    }, [_vm._v("\n          " + _vm._s(keyword) + "\n        ")])
  }), _vm._v(" "), (_vm.inputVisible.saveOptinInput) ? _c('el-input', {
    ref: "saveOptinInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": function($event) {
        return _vm.handleInputConfirm(_vm.company.optinKeywords, 'saveOptinInput')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm(_vm.company.optinKeywords, 'saveOptinInput')
      }
    },
    model: {
      value: (_vm.inputValue.saveOptinInput),
      callback: function($$v) {
        _vm.$set(_vm.inputValue, "saveOptinInput", $$v)
      },
      expression: "inputValue.saveOptinInput"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showInput('saveOptinInput')
      }
    }
  }, [_vm._v("+ New Keyword")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opt-out Keywords",
      "prop": "cume"
    }
  }, [_vm._l((_vm.company.optoutKeywords), function(keyword) {
    return _c('el-tag', {
      key: keyword,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(_vm.company.optoutKeywords, keyword)
        }
      }
    }, [_vm._v("\n          " + _vm._s(keyword) + "\n        ")])
  }), _vm._v(" "), (_vm.inputVisible.saveOptoutInput) ? _c('el-input', {
    ref: "saveOptoutInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": function($event) {
        return _vm.handleInputConfirm(_vm.company.optoutKeywords, 'saveOptoutInput')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm(_vm.company.optoutKeywords, 'saveOptoutInput')
      }
    },
    model: {
      value: (_vm.inputValue.saveOptoutInput),
      callback: function($$v) {
        _vm.$set(_vm.inputValue, "saveOptoutInput", $$v)
      },
      expression: "inputValue.saveOptoutInput"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showInput('saveOptoutInput')
      }
    }
  }, [_vm._v("+ New Keyword")])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.handleUpdateCompany
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ea0f6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/company/CompanyDetail.vue
// module id = 3189
// module chunks = 3